if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        this.sliderOptions = {
          slidesPerView: '1',
          spaceBetween: 10,
          loop: !this.hasAttribute('data-cards'),
          ...(this.hasAttribute('data-cards') && {
            slidesPerView: 2,
            spaceBetween: 12,
            autoHeight: false,
            breakpoints: { 768: { slidesPerView: 3, spaceBetween: 16 } },
          }),
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };
      }

      connectedCallback() {
        this.removeCurrentProduct();
        const slider = this.querySelector('.swiper');
        this.sliderInstance = new window.FoxTheme.Carousel(slider, this.sliderOptions);
        this.sliderInstance.init();

        this.fixQuickviewDuplicate();
      }

      // Collection sourced cards can include the product being viewed; drop it.
      removeCurrentProduct() {
        const url = this.closest('product-recommendations')?.dataset.url;
        const id = url && new URL(url, location.origin).searchParams.get('product_id');
        if (id) this.querySelector(`.swiper-slide[data-product-id="${id}"]`)?.remove();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
